"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetch = fetch;

var _ImmutableAPI = require("crm_data/api/ImmutableAPI");

var HAS_EMAIL_ENGAGEMENTS_URI = 'engagements/v1/engagements/has-associated-email';

function fetch(objectType, subjectId) {
  var url = HAS_EMAIL_ENGAGEMENTS_URI + "/" + objectType + "/" + subjectId;
  return (0, _ImmutableAPI.get)(url);
}